import { useMemo, useState } from "react";
import {
  formatCrypto,
  formatCurrency,
  getAssetCoin,
  getAssetName,
} from "../../utils";
import CoinLogo from "../commons/CoinLogo";
import SkeletonCard from "../skeletons/SkeletonCard";

export const Portfolio = ({ assets, loading, isExchange }) => {
  function formatChange(change, changeValue) {
    const hasPercent = change?.toString().includes("%");
    const value = hasPercent ? change : `${change}%`;
    return !isNaN(changeValue) && changeValue > 0 ? `+${value}` : value;
  }

  return (
    <div className="w-full overflow-x-auto rounded-lg">
      <table className="w-full text-sm">
        <thead className="bg-white">
          <tr>
            <th
              scope="col"
              className="p-4 w-[30%] text-left font-bold text-slate-600"
            >
              Token
            </th>
            {/* {isExchange && ( */}
            <th
              scope="col"
              className="p-4 w-[17.5%] text-center font-bold text-slate-600"
            >
              Exchange
            </th>
            {/* )} */}
            <th
              scope="col"
              className="p-4 w-[17.5%] text-center font-bold text-slate-600"
            >
              Amount
            </th>
            <th
              scope="col"
              className="p-4 w-[17.5%] text-center font-bold text-slate-600 whitespace-nowrap"
            >
              Price (USDT)
            </th>
            <th
              scope="col"
              className="p-4 w-[17.5%] text-center font-bold text-slate-600"
            >
              24H Change
            </th>
            <th
              scope="col"
              className="p-4 w-[17.5%] text-center font-bold text-slate-600 whitespace-nowrap"
            >
              Total (USDT)
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            [...Array(5)].map((_, idx) => (
              <tr
                key={idx}
                className="border-t border-slate-200 hover:bg-slate-50"
              >
                <td className="p-4 text-left font-medium text-slate-900 flex items-center gap-2 text-sm">
                  <SkeletonCard type="avatar" avatarSize={24} />
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>
                <td className="p-4 text-center text-slate-700 text-sm">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>

                <td className="p-4 text-center text-slate-700 text-sm">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>
                <td className="p-4 text-center text-slate-700 text-sm">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>
                <td className={`p-4 text-center font-medium text-sm`}>
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>
                <td className="p-4 text-center font-semibold text-slate-900 text-sm">
                  <SkeletonCard
                    type="text"
                    lines={1}
                    widths={["50px"]}
                    heights={["10px"]}
                  />
                </td>
              </tr>
            ))
          ) : assets?.length ? (
            assets.map((asset, index) => {
              const changeValue = parseFloat(asset.change);
              let changeColorClass = "text-slate-700"; // Warna default untuk nilai netral seperti '-'
              if (!isNaN(changeValue)) {
                if (changeValue >= 0) {
                  changeColorClass = "text-green-600"; // Hijau untuk positif
                } else {
                  changeColorClass = "text-red-600"; // Merah untuk negatif
                }
              }

              // Usage
              const displayChange = formatChange(asset.change, changeValue);

              return (
                <tr
                  key={index}
                  className="border-t border-slate-200 hover:bg-slate-50"
                >
                  <td className="max-md:flex max-md:w-[100px] uppercase p-4 text-left font-medium text-slate-900 flex items-center gap-2 text-sm">
                    <CoinLogo
                      asset={getAssetName(asset.token)}
                      className="max-w-full object-contain uppercase !w-[24px] !h-[24px] rounded-full"
                    />
                    {/* <img
                      src={`/images/coin_icon/${(asset.token.split("/").length
                        ? asset.token.split("/")[0]
                        : asset.token
                      ).toUpperCase()}.png`}
                      src={getAssetCoin(
                        asset.token.split("/").length
                          ? asset.token.split("/")[0]
                          : asset.token
                      )}
                      alt={"token"}
                      className="max-w-full object-contain uppercase !w-[24px] h-[24px] rounded-full"
                    /> */}
                    {asset.token}
                  </td>
                  {/* {isExchange && ( */}
                  <td className="p-4  items-center text-center text-slate-700 text-sm">
                    <div className="flex justify-center gap-1 items-center capitalize">
                      <img
                        src={`/images/icons/icon_wallet_${
                          asset?.exchange?.toLowerCase().startsWith("osl")
                            ? "osl"
                            : asset?.exchange
                        }.svg`}
                        alt=""
                        className="w-full max-w-[20px] h-[20px] rounded-full mr-2"
                      />
                      {asset?.exchange?.toLowerCase().startsWith("osl")
                        ? "OSL"
                        : asset?.exchange}
                    </div>
                  </td>
                  {/* )} */}

                  <td className="p-4 text-center text-slate-700 text-sm">
                    {formatCrypto(asset.amount || 0)}{" "}
                    {getAssetName(asset.token)}
                  </td>
                  <td className="p-4 text-center text-slate-700 text-sm">
                    ${formatCrypto(asset.price || 0)}
                  </td>
                  <td
                    className={`p-4 text-center font-medium ${changeColorClass} text-sm`}
                  >
                    {asset.change === "-" ? "-" : displayChange}
                  </td>
                  <td className="p-4 text-center font-semibold text-slate-900 text-sm">
                    ${formatCurrency(asset.total_usdt || 0)}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                className="h-[7rem]  p-3 text-sm text-center text-gray-400"
                colSpan={6}
              >
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export const PortfolioSection = ({ dashboard, loading }) => {
  const [hideSmallAssets, setHideSmallAssets] = useState(false);

  // filter logic fixed
  const filteredAssets = useMemo(() => {
    const data = dashboard?.table_data || [];
    if (!hideSmallAssets) return data;
    return data.filter((a) => (a.total_usdt || 0) >= 1);
  }, [dashboard?.table_data, hideSmallAssets]);

  return (
    <div className="flex flex-col md:flex-row gap-4 p-4 bg-white rounded-lg">
      <div className="w-full">
        {/* Header Saldo Total & Toggle */}
        <div className="flex items-end justify-between mb-3">
          <p className="text-3xl font-bold text-slate-900">
            ${formatCurrency(dashboard?.summary?.aggregate_balance_usdt || 0)}
          </p>
          <label className="flex items-center space-x-2 !cursor-pointer">
            <input
              type="checkbox"
              checked={hideSmallAssets}
              onChange={() => setHideSmallAssets((v) => !v)}
              className="form-checkbox h-4 w-4 text-blue-600 !cursor-pointer"
            />
            <span className="text-sm text-gray-700">Hide &lt; 1 USDT</span>
          </label>
        </div>

        {/* Tabel Aset */}
        <Portfolio loading={loading} assets={filteredAssets} />
      </div>
    </div>
  );
};

// Anda bisa mengekspor PortfolioPage untuk digunakan di file App.js Anda.
// export default PortfolioPage;
